import { Box, Typography } from "@mui/material"
import type { FC, ReactElement } from "react"

interface StepSectionLabelProps {
  icon: ReactElement
  label: string
  required?: boolean
}

export const StepSectionLabel: FC<StepSectionLabelProps> = ({ icon, label, required }) => (
  <Box className='flex items-center gap-2'>
    <Box className='text-gray-600'>{icon}</Box>
    <Typography className='text-ml font-normal text-primary'>
      {label}
      {required && (
        <Box component='span' className='text-red-600'>
          *
        </Box>
      )}
    </Typography>
  </Box>
)
